module.exports = __webpack_public_path__ + "7528237237f645e204dcd54ef08f0c79.svg";